<template>
  <div class="accordion" id="collapse-alert">
    <alert-diary
      v-if="maxDaysAfterAlertMed > 0"
      :diary-type="'med'"
      :url-alert-diary="urlAlertDiary"
      :max-days-after-alert="maxDaysAfterAlertMed"
      :is-active="maxDaysAfterAlertMed > 0"
    />
    <alert-diary
      v-if="maxDaysAfterAlertSan > 0"
      :diary-type="'san'"
      :url-alert-diary="urlAlertDiary"
      :max-days-after-alert="maxDaysAfterAlertSan"
      :is-active="maxDaysAfterAlertMed <= 0"
    />
    <alert-diary
      v-if="maxDaysAfterAlertSoas > 0"
      :diary-type="'soas'"
      :url-alert-diary="urlAlertDiary"
      :max-days-after-alert="maxDaysAfterAlertSoas"
      :is-active="maxDaysAfterAlertSoas <= 0"
    />
    <alert-somministration
      v-if="alertTherapy"
      :link-somministrations="linkSomministrations"
      :url-alert-therapy="urlAlertTherapy"
      :is-active="maxDaysAfterAlertSan + maxDaysAfterAlertMed + maxDaysAfterAlertSoas <= 0"
      :hours-not-administered="hoursNotAdministered"
    />
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import alertDiary from '../welcomeAlert/alertDiary';
import alertSomministration from '../welcomeAlert/alertSomministration';
export default {
  components: {
    alertDiary,
    alertSomministration,
  },
  name: 'collapseAlert',
  props: [
    'maxDaysAfterAlertMed',
    'maxDaysAfterAlertSan',
    'maxDaysAfterAlertSoas',
    'urlAlertDiary',
    'urlAlertTherapy',
    'linkSomministrations',
    'alertTherapy',
    'hoursNotAdministered',
  ],
};
</script>
